<template>
  <div class="footer_outer_box">
    <!-- <div class="footer"> -->
    <div class="f-main">
      <div class="f-vode-img">
        <img src="../../assets/imgs/wxcode.jpg" alt="" />
        <p class="f-p">{{ $t('lang.FooterOther.zs3eck') }}</p>
      </div>
      <div class="f-body">
        <div class="f-body-top">
          <p class="f-body-top-p">{{ $t('lang.FooterOther.ktb2ur') }}</p>
        </div>
        <div class="f-body-center">
          <p class="f-body-center-p">{{ $t('lang.FooterOther.6yyjjc') }}</p>
        </div>

        <div class="f-body-bottom">
          <p class="f-body-bottom-p">
            ©2023 {{ $t('lang.FooterOther.re5sad') }}
          </p>
        </div>
        <div class="forGongShang">
          <img
            class="chinaStyle"
            src="../../views/home/image/China.png"
          />浙ICP备19025291
        </div>
      </div>
      <div class="f-body-link">
        <div class="f-body-link-top">
          <p class="f-body-link-top-p">{{ $t('lang.FooterOther.usnxbi') }}</p>
        </div>
        <div class="f-body-link-center">
          <i
            class="el-icon-phone"
            style="font-size: 25px; margin: auto 0 auto 0; color: #ffffff"
          ></i>
          <div class="f-body-link-center-p">+86-0571-86375773</div>
        </div>

        <div class="f-body-link-center">
          <i
            class="el-icon-message"
            style="font-size: 25px; margin: auto 0 auto auto; color: #ffffff"
          ></i>
          <div class="f-body-link-center-p">service@minderwork.com</div>
        </div>
        <div class="f-body-link-center">
          <i
            class="el-icon-location-outline"
            style="color: #ffffff; font-size: 25px; margin: auto 0 auto auto"
          ></i>
          <div class="f-body-link-center-p">Hangzhou Zhejiang PRC.</div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
import api from '../../js/api';

export default {
  name: 'FooterV',
  data() {
    return {
      urlList: [],
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less">
.footer_outer_box {
  width: 100%;
  min-height: 300px;
  opacity: 0.8;
  background-image: url(./../../assets/imgs/foot.png);
  background-size: cover;
}
.f-main {
  padding: 90px 5% 0 5%;
  display: grid;
  grid-template-columns: auto auto auto;
  grid-column-gap: 5%;
}
.f-vode-img {
  width: 100%;
  img {
    border-radius: 50%;
    width: 204px;
    height: 204px;
    object-fit: cover;
    object-position: 50% 50%;
    opacity: 0.8;
  }
}
.f-p {
  // font: normal normal normal 18px avenir-lt-w01_35-light1475496,
  // avenir-lt-w05_35-light, sans-serif;
  font-size: 18px;
  text-align: center;
  width: 204px;
  margin: auto;
  margin-top: 14px;
  color: #ffffff;
  font-weight: 300;
}
.f-body {
  display: grid;
  grid-template-rows: auto;
  // grid-row-gap: 30px;
  margin: 40px auto 0px auto;
}
.f-body-top {
  height: auto;
  width: 220px;
  text-align: center;
  margin: auto;
}
.f-body-center {
  height: auto;
  width: 298px;
  text-align: center;
  margin: auto;
}
.f-body-bottom {
  height: auto;
  width: 349px;
  text-align: center;
  margin: 30px auto auto auto;
}
.f-body-top-p {
  line-height: 1.41em;
  font-size: 22px;
  font-weight: bold;
  color: #ffffff;
}
.f-body-center-p {
  line-height: 1.41em;
  color: #ffffff;
  font-size: 20px;
}
.f-body-bottom-p {
  line-height: 1.79em;
  font-size: 18px;
  font-weight: 200;
  color: #ffffff;
}
.f-body-link {
  display: grid;
  grid-template-rows: auto;
  grid-row-gap: 20px;
  margin: 0px auto 30px auto;
}
.f-body-link-top {
  width: 147px;
  height: auto;
  text-align: center;
  margin: auto;
}
.f-body-link-top-p {
  font-size: 25px;
  font-weight: bold;
  color: #ffffff;
}
.f-body-link-center {
  width: auto;
  text-align: center;
  display: flex;
}
.f-body-link-center-p {
  font-size: 20px;
  // width: 210px;
  text-align: left;
  color: #ffffff;
  margin: auto auto auto 10px;
}
.forGongShang {
  color: #ffffff;
  font-size: 15px;
  cursor: pointer;
  margin: 0 auto;
  .chinaStyle {
    width: 25px;
  }
}
</style>
